<div *ngIf="emailConversation$ | async as emailConversation"
     class="item traversable-list-item"
     [ngClass]="itemStyle$ | async"
     [class.opened]="isOpened"
     [class.focus]="isFocused"
     [attr.tabindex]="0"
     (click)="selectConversation(emailConversation, true)"
     (keydown.enter)="selectConversation(emailConversation, true)"
     (keydown.shift.enter)="selectConversation(emailConversation, false)">
  <div class="item-inner">
    <div class="visitor-avatar">
      <svg-icon icon="{{ (newItem$ | async) ? 'mail' : 'mail-open' }}"></svg-icon>
    </div>
    <workitem-simple-timer [initialTime]="connectedTime$ | async"
                           [showRemainingSeconds]="isSecondsRemainingVisible$ | async"
                           [remainingSeconds]="emailAlertingTimeout$ | async | appFormatSeconds"
                           [showTimer]="true"
                           (onTimerTextChanged)="timerTextChanged()">
    </workitem-simple-timer>

    <ng-container *ngIf="emptyProactive$ | async">
      <div class="sender-name gc-text-bold">{{ 'bcWorkItemGenesysEmailList.newMessage' | translate }}</div>
    </ng-container>

    <ng-container *ngIf="externalContactFullName$ | async as fullName else normalNameTpl">
      <div class="sender-name gc-text-bold">{{ fullName }}</div>
    </ng-container>
    <ng-template #normalNameTpl>
      <div class="sender-name gc-text-bold">{{ name$ | async }}</div>
    </ng-template>

    <div *ngIf="error$ | async"
         class="error-indicator">
      <svg-icon icon="alert"></svg-icon>
    </div>

    <div class="messages">
      <ng-container *ngIf="emptyProactive$ | async; else normalEmailTpl">
        <i class="glyphicon glyphicon-pencil"></i>
      </ng-container>
      <ng-template #normalEmailTpl>
        <div class="mail-subject gc-text-bold">{{ subject$ | async }}</div>
        <div class="mail-text">{{ textBody$ | async }}</div>
      </ng-template>
      <div class="shortcut">
        <svg-icon icon="enter-key"></svg-icon>
      </div>
    </div>
  </div>
</div>
